import styled from 'styled-components';

import { FolderRow } from 'ui/indexPages/folders/folderRow';
import { Skeleton } from 'ui/skeleton';
import { colors, spacing } from 'ui/theme';
import { Checkbox, CHECKBOX_STATUS } from 'ui/checkbox';
import { Overflow } from 'ui/icons';
import { SecondaryButton } from 'ui/button';
import { pxToRem } from 'utils/convert';

import { TableCell } from './TableCell';

const StyledTableCell = styled(TableCell)`
  height: ${pxToRem(36)};
  grid-column: 2 / span 2;
`;

const StyledButton = styled(SecondaryButton)`
  padding: 0 ${spacing.half};
`;

const SkeletonCell = () => (
  <StyledTableCell>
    <Skeleton />
  </StyledTableCell>
);

export const WorkflowFolderSkeletonRow = ({ index }: { index: number }) => (
  <FolderRow id={index.toString()}>
    <TableCell data-test="checkbox-grid-cell">
      <Checkbox status={CHECKBOX_STATUS.UNCHECKED} isDisabled />
    </TableCell>
    <SkeletonCell />
    <TableCell>
      <StyledButton onClick={() => null} isDisabled>
        <Overflow color={colors.grey90} />
      </StyledButton>
    </TableCell>
  </FolderRow>
);
